import {
  AdvanceSalaryDetail,
  AdvanceSalaryRepaymentDetails,
  AdvanceSalaryRepaymentStatus,
  AdvanceSalaryStatus,
  InterestRateTypeEnum,
} from "../../../dto";
import { AdvanceSalaryDetails } from "../../../models";

export interface AdvanceSalarySearchContext {
  month: number;
  year: number;
  status: AdvanceSalaryStatus;
  pageNo: number;
  pageSize: number;
}

export function findEmiDetailsByLoanId(context: {
  data: AdvanceSalaryDetails;
  loanId: string;
}) {
  const { data, loanId } = context;
  const loan = data.find((item) => item.loanId === loanId);
  return loan ? loan.repaymentDetails : [];
}

/**
 * Calculates the sum of all amounts in AdvanceSalaryRepaymentDetails
 * @param repaymentDetails - Array of repayment details
 * @returns Total sum of all amounts
 */
export function calculateRepaymentSum(
  repaymentDetails: AdvanceSalaryRepaymentDetails,
): number {
  return repaymentDetails.reduce((sum, detail) => sum + detail.amount, 0);
}

/**
 * Calculates the sum of amounts from an AdvanceSalaryDetail object
 * @param advanceSalaryDetail - The advance salary detail object
 * @returns Total sum of all repayment amounts
 */
export function calculateAdvanceSalarySum(
  advanceSalaryDetail: AdvanceSalaryDetail,
): number {
  return calculateRepaymentSum(advanceSalaryDetail.repaymentDetails);
}

/**
 * Calculates the sum of amounts with optional filtering by status
 * @param repaymentDetails - Array of repayment details
 * @param statusFilter - Optional status to filter by
 * @returns Total sum of amounts matching the filter
 */
export function calculateRepaymentSumByStatus(
  repaymentDetails: AdvanceSalaryRepaymentDetails,
  statusFilter?: AdvanceSalaryRepaymentStatus,
): number {
  const filteredDetails =
    statusFilter !== undefined
      ? repaymentDetails.filter((detail) => detail.status === statusFilter)
      : repaymentDetails;

  return filteredDetails.reduce((sum, detail) => sum + detail.amount, 0);
}

export function formatInterestRateType(
  interestRateType?: InterestRateTypeEnum,
): string {
  if (!interestRateType) return "—";
  return interestRateType
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
